import product1 from './ecomm dummy products/product1.2.webp';
import product2 from './ecomm dummy products/product2.2.webp';
import product3 from './ecomm dummy products/product3.2.webp';
import product4 from './ecomm dummy products/product4.2.webp';
import product5 from './ecomm dummy products/product5.2.webp';
import product6 from './ecomm dummy products/product6.2.webp';
import product7 from './ecomm dummy products/product7.2.webp';
import product8 from './ecomm dummy products/product8.2.webp';
import product9 from './ecomm dummy products/product9.2.webp';

let productsModeled = [product1, product2, product3, product4, product5, product6, product7, product8, product9];

export default productsModeled;